import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "element-metadata"
    }}>{`Element Metadata`}</h1>
    <h2 {...{
      "id": "get-and-set-element-metadata"
    }}>{`Get and Set Element Metadata`}</h2>
    <p>{`Add-ons can store `}<strong parentName="p">{`private metadata`}</strong>{` (custom data accessible only to the add-on that set it) on any node within the Express document. Currently, each node can hold up to `}<strong parentName="p">{`3 KB`}</strong>{` of data, organized as key/value pairs where both keys and values are Strings. Additionally, there is a limit of `}<strong parentName="p">{`20 key/value pairs`}</strong>{` per node.`}</p>
    <p>{`All nodes that inherit from the `}<a parentName="p" {...{
        "href": "../../../references/document-sandbox/document-apis/classes/BaseNode.md"
      }}><inlineCode parentName="a">{`BaseNode`}</inlineCode></a>{` class have a `}<inlineCode parentName="p">{`addOnData`}</inlineCode>{` property that can be used to store and retrieve metadata. It is an instance of the `}<a parentName="p" {...{
        "href": "../../../references/document-sandbox/document-apis/classes/AddOnData.md"
      }}><inlineCode parentName="a">{`AddOnData`}</inlineCode></a>{` class, which provides methods to perform operations such as `}<inlineCode parentName="p">{`getItem()`}</inlineCode>{`, `}<inlineCode parentName="p">{`setItem()`}</inlineCode>{`, `}<inlineCode parentName="p">{`removeItem()`}</inlineCode>{`, and `}<inlineCode parentName="p">{`clear()`}</inlineCode>{`.`}</p>
    <p>{`With the `}<inlineCode parentName="p">{`remainingQuota`}</inlineCode>{` property, you can check how much space is left, both in terms of `}<inlineCode parentName="p">{`sizeInBytes`}</inlineCode>{` and `}<inlineCode parentName="p">{`numKeys`}</inlineCode>{`, while `}<inlineCode parentName="p">{`keys()`}</inlineCode>{` returns an array of the keys in use.`}</p>
    <InlineAlert slots="text" variant="info" mdxType="InlineAlert" />
    <p>{`While Document and Page metadata operate from the `}<inlineCode parentName="p">{`addOnUISdk.app.document`}</inlineCode>{` object and belong to the `}<a parentName="p" {...{
        "href": "../../../references/addonsdk/index.md"
      }}>{`Add-on UI SDK`}</a>{`, Element metadata are part of the `}<a parentName="p" {...{
        "href": "../../../references/document-sandbox/document-apis/index.md"
      }}>{`Document Sandbox`}</a>{` and are accessed through the `}<inlineCode parentName="p">{`node.addOnData`}</inlineCode>{` property.`}</p>
    <h3 {...{
      "id": "example"
    }}>{`Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { editor } from "express-document-sdk";

// Create some dummy node
const text = editor.createText("Hello, World!");

// Store some metadata as key/value pairs
text.addOnData.setItem("originalText", "Hello, World!");
text.addOnData.setItem("date", new Date().toISOString());

// Retrieve the metadata
console.log("Original text: ", text.addOnData.getItem("originalText"));

// Check the remaining quota
console.log("Remaining quota: ", text.addOnData.remainingQuota);
// {
//   "sizeInBytes": 3062,
//   "numKeys": 19
// }

// Check the keys in use
console.log("Keys in use: ", text.addOnData.keys());
// ["originalText", "date"]

// Remove the metadata
text.addOnData.removeItem("originalText");

// clear all metadata
text.addOnData.clear();
`}</code></pre>
    <p>{`Please note that the `}<inlineCode parentName="p">{`addOnData`}</inlineCode>{` property is iterable with `}<inlineCode parentName="p">{`for...of`}</inlineCode>{` loops, so you can use it to iterate over the key/value pairs; each pair is an array with the key as the first element and the value as the second.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// iterate over key/value pairs
for (let pair of text.addOnData) {
  console.log(pair);
  // ['originalText', 'Hello, World!']
  // ['date', '2025-01-20T11:06:19.051Z']
}
`}</code></pre>
    <p>{`Alternatively, you can use the `}<inlineCode parentName="p">{`keys()`}</inlineCode>{` method to get an array of all keys and then iterate over them.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Iterate over all keys
text.addOnData.keys().forEach((key) => {
  console.log(\`Key: \${key}, Value: \${text.addOnData.getItem(key)}\`);
});
`}</code></pre>
    <h2 {...{
      "id": "use-cases"
    }}>{`Use Cases`}</h2>
    <p>{`Per-element metadata can be useful to keep track, for example, of the original properties a node has been created with, the history of the subsequent changes made to it, or to tag some nodes in a way that is meaningful for the add-on (e.g., it's supposed to be skipped when a certain routine is launched). It can also be used to store temporary data that is not meant to be persisted.`}</p>
    <p>{`Please, refer to the SDK Reference section for `}<a parentName="p" {...{
        "href": "../../../references/document-sandbox/document-apis/classes/AddOnData.md"
      }}><inlineCode parentName="a">{`AddOnData`}</inlineCode></a>{` for a complete list of methods, and the `}<a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/express-add-on-samples/tree/main/document-sandbox-samples/per-element-metadata"
      }}><inlineCode parentName="a">{`per-element-metadata`}</inlineCode></a>{` sample add-on for a demonstrative implementation.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      